module.exports = __webpack_public_path__ + "img/bid_icon.e4b486a2.svg";